import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import arrowIcon from '../../arrowDown.svg.js';
import controllerArrowIcon from '../../controllerArrowDown.svg.js';
import TooltipOnEllipsis from '../../tooltipOnEllipsis';
import KEYS from '../../../common/keyCodes';
import { dataHooks } from '../../dropDownBase/constants';

var STOP_PROPAGATION_KEYS = _.pick(KEYS, ['BACKSPACE', 'LEFT', 'UP', 'RIGHT', 'DOWN', 'ENTER', 'SPACE', 'ESC', 'Z']);

var getSelectedContentProps = function getSelectedContentProps(props) {
  return {
    key: 'selected',
    className: "selected-content ".concat(props.hasArrowIcon ? 'has-arrow-icon' : '', " ").concat(props.illustrationOnly ? 'illustration-only' : '', " ").concat(props.isPlaceholder ? 'placeholder' : '')
  };
};

var cloneChildrenIfNeeded = function cloneChildrenIfNeeded(props) {
  if (!props.multiSelect && (props.isVisible === null || ! /*#__PURE__*/React.isValidElement(props.children) || _.get(props.children, 'type') === 'div')) {
    return props.children;
  }

  return /*#__PURE__*/React.cloneElement(props.children, {
    shouldTranslate: props.shouldTranslate,
    selected: props.selected,
    isSelectedElement: props.isSelectedElement,
    isVisible: props.isVisible,
    wasVisible: props.wasVisible,
    checkbox: props.multiSelect
  }, props.children.props.children);
};

var getChildren = function getChildren(props) {
  return /*#__PURE__*/React.createElement('div', getSelectedContentProps(props), _.isString(props.children) ? props.translateIfNeeded(props.children) : cloneChildrenIfNeeded(props));
};

var getArrowIfNeeded = function getArrowIfNeeded(props) {
  return props.hasArrowIcon ? /*#__PURE__*/React.createElement('span', {
    className: "symbol-arrow-down ".concat(props.smallArrow ? 'dark-skin' : ''),
    key: 'arrow'
  }, props.smallArrow ? /*#__PURE__*/React.createElement(controllerArrowIcon) : /*#__PURE__*/React.createElement(arrowIcon)) : null;
};

var OptionRaw = /*#__PURE__*/function (_React$Component) {
  _inherits(OptionRaw, _React$Component);

  var _super = _createSuper(OptionRaw);

  function OptionRaw() {
    _classCallCheck(this, OptionRaw);

    return _super.apply(this, arguments);
  }

  _createClass(OptionRaw, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.selected && this.props.onSelectedMount) {
        this.props.onSelectedMount(this);
      }

      if (this.props.active && this.props.onActive) {
        this.props.onActive(this);
      }

      if (this.props.onMount) {
        this.props.onMount(this);
      }
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (nextProps.active && !this.props.active && this.props.onActive) {
        this.props.onActive(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.active) {
        this.props.onActive(null);
      }

      if (this.props.selected && this.props.onSelectedMount) {
        this.props.onSelectedMount(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var onMouseEnter = props.onMouseEnter,
          label = props.label;

      var onClick = function onClick() {
        return props.disabled ? _.noop() : props.onClick(props.value);
      };

      var className = ['control-dropdown-option', props.selected && !props.multiSelect ? 'selected' : '', props.disabled ? 'disabled' : '', props.active ? 'active' : '', props.optionWrapperClassName || ''].join(' ');
      return /*#__PURE__*/React.createElement('div', {
        className: className,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        disabled: props.disabled,
        'data-aid': props.automationId,
        'data-hook': props.dataHook,
        'data-option': dataHooks.dataOptionWithValueAndLabel(props.value, label)
      }, getChildren(_.assign({}, props, {
        selected: props.selected
      })));
    }
  }]);

  return OptionRaw;
}(React.Component);

var SelectedRaw = function SelectedRaw(props) {
  return /*#__PURE__*/React.createElement('div', {
    key: props.key,
    className: 'selected-container',
    'data-hook': 'selected-dropdown'
  }, [getChildren(_.assign({}, props, {
    isSelectedElement: true
  })), getArrowIfNeeded(props)]);
};

var lastSelection = {
  start: null,
  end: null
};
var pendingBackspace = false;

var isUndoRedo = function isUndoRedo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === KEYS.Z;
};

var onSearchBoxKeyDown = function onSearchBoxKeyDown(e) {
  if (e.keyCode === KEYS.BACKSPACE) {
    var _e$target = e.target,
        value = _e$target.value,
        selectionStart = _e$target.selectionStart,
        selectionEnd = _e$target.selectionEnd;

    if (value !== '') {
      pendingBackspace = true;
    }

    if (_.isNumber(selectionStart) || _.isNumber(selectionEnd)) {
      lastSelection.start = selectionStart;
      lastSelection.end = selectionEnd;
    }
  } else if (e.keyCode === KEYS.UP || e.keyCode === KEYS.DOWN || isUndoRedo(e)) {
    e.preventDefault();
    e.stopPropagation();
  } else if (_(STOP_PROPAGATION_KEYS).values().includes(e.keyCode)) {
    e.stopPropagation();
  }
};

var SearchBoxRaw = /*#__PURE__*/function (_React$Component2) {
  _inherits(SearchBoxRaw, _React$Component2);

  var _super2 = _createSuper(SearchBoxRaw);

  function SearchBoxRaw() {
    _classCallCheck(this, SearchBoxRaw);

    return _super2.apply(this, arguments);
  }

  _createClass(SearchBoxRaw, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.props.registerInputToAllowEvents(this.input);
      this.props.onChange(this.props.selectedValue, function () {
        var inputElement = ReactDOM.findDOMNode(_this.input);

        if (inputElement) {
          inputElement.focus();
          inputElement.select();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.registerInputToAllowEvents(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var searchTerm = _.toLower(this.props.searchTerm);

      var value = _.toLower(this.props.value);

      if (_.startsWith(value, searchTerm)) {
        var inputElement = ReactDOM.findDOMNode(this.input);

        if (inputElement) {
          var selectionStart = searchTerm.length;

          if (selectionStart > 0) {
            inputElement.selectionStart = selectionStart;
          }
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var value = e.target.value;
      var selectionEnd = e.target.selectionEnd;
      var lastSelectionLength = lastSelection.end - lastSelection.start;
      var shouldSlice = pendingBackspace && lastSelectionLength > 0 && selectionEnd === value.length && selectionEnd !== 0 && value.length > 0;

      if (shouldSlice) {
        value = value.slice(0, -1);
      }

      pendingBackspace = false;
      this.props.onChange(value);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      onSearchBoxKeyDown(e);

      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement('div', {
        key: this.props.key,
        className: 'selected-container'
      }, [/*#__PURE__*/React.createElement('input', {
        className: 'selected-input' + (this.props.hasArrowIcon ? ' has-arrow-icon' : '') + (this.props.illustrationOnly ? ' illustration-only' : ''),
        value: this.props.value,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        spellCheck: false,
        key: 'input',
        ref: function ref(input) {
          _this2.input = input;
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onKeyDown(e);
        },
        placeholder: this.props.placeholder
      }), getArrowIfNeeded(this.props)]);
    }
  }]);

  return SearchBoxRaw;
}(React.Component);

var SelectedTextContainerRaw = function SelectedTextContainerRaw(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "selected-text-container"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    marginTop: -10,
    closeOnMouseClick: true
  }, /*#__PURE__*/React.createElement("div", null, props.value)));
};

OptionRaw.displayName = 'Option';
SelectedRaw.displayName = 'Selected';
SearchBoxRaw.displayName = 'SearchBox';
SelectedTextContainerRaw.displayName = 'SelectedTextContainer';
export var Option = compose(OptionRaw);
export var Selected = compose(SelectedRaw);
export var SearchBox = compose(SearchBoxRaw);
export var SelectedTextContainer = compose(SelectedTextContainerRaw);